import React from 'react'
import { useSearchParams } from 'react-router-dom'

import { HistoryParticipationType } from './BanksParticipation.types'
import styles from './MainInfo.module.scss'
import { BrokenBanks, UnBrokenBanks } from './components'

interface Props {
  historyParticipations: HistoryParticipationType[]
}

const MainInfo: React.FC<Props> = ({ historyParticipations }) => {
  const [searchParams] = useSearchParams()
  const mode = searchParams.get('mode')

  return (
    <>
      <div className={styles.wrapper}>
        {mode === 'broken' && (
          <BrokenBanks historyParticipations={historyParticipations.filter((item) => item.type !== 'WAITING')} />
        )}
        {mode === 'unbroken' && (
          <UnBrokenBanks historyParticipations={historyParticipations.filter((item) => item.type === 'WAITING')} />
        )}
      </div>
    </>
  )
}

export default MainInfo
